const ACTION_LIST = ["Created", "Updated", "Solved"];
const CONDITION_LIST = [{ name: "Before", value: "<" }, { name: "After", value: ">" }];
const STATUS_LIST = ["New", "Open", "Closed", "Pending", "Solved", "Hold"];
const OPERATOR_LIST = [{ name: "Less", value: "<" }, { name: "Greater", value: ">" }];
const RELATIVE_TIME_LIST = ["Days", "Months", "Years"];
const TYPE_LIST = ["Ticket", "User"];

export { ACTION_LIST, CONDITION_LIST, STATUS_LIST, OPERATOR_LIST, RELATIVE_TIME_LIST, TYPE_LIST };